import { getEnvironment } from "@/Environment";
import { QRCodeSVG } from "qrcode.react";

interface PairMobileDeviceQrCardProps {
  /** The pairing nonce to encode, or undefined before the first code loads. */
  nonce: string | undefined;
  /** Dim the card once the current code has expired. */
  dimmed: boolean;
}

/**
 * The framed, animated QR card for mobile-device pairing. Feature-specific
 * chrome — the white frame keeps the code scannable (so it stays white in dark
 * mode too; a dark quiet zone breaks camera detection), `key={nonce}` remounts
 * the card whenever a new code is minted so the flip-in animation replays and
 * the refresh is obvious, and `dimmed` fades it once the code expires.
 */
export function PairMobileDeviceQrCard({
  nonce,
  dimmed,
}: PairMobileDeviceQrCardProps) {
  return (
    <div
      key={nonce}
      className={`qr-refresh-animation rounded-xl border border-gray-200 bg-white p-6 transition-opacity ${
        dimmed ? "opacity-20" : "opacity-100"
      }`}
      data-testid="pair-mobile-device-qr"
    >
      {nonce !== undefined && (
        // The environment rides along in the payload so the app can say
        // "that code is for Production, you're on Demo" instead of reporting
        // a 401 as an expired code. A nonce is base64url, so it can never
        // contain the separator. Older apps still parse `fs-pair:<nonce>`;
        // see PairingCoordinator.parse.
        <QRCodeSVG value={`fs-pair:${getEnvironment()}:${nonce}`} size={220} />
      )}
    </div>
  );
}
